<template>
  <transition name="fade">
    <div v-if="visible" class="alert-overlay" @click.self="fechar">
      <div class="alert-box">
        <h5 class="mb-2"><b>{{ title }}</b></h5>
        <p class="text-muted mb-3">{{ message }}</p>

        <div class="alert-actions">
          <button class="btn btn-primary botao-azul" @click="fechar">
            OK
          </button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AlertModal',
  props: {
    visible: Boolean,
    title: String,
    message: String,
    type: {
      type: String,
      default: 'info'
    }
  },
  methods: {
    fechar() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.alert-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
}

.alert-box {
  background: white;
  border-radius: 12px;
  padding: 20px;
  width: 100%;
  max-width: 380px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
}

.alert-actions {
  display: flex;
  justify-content: flex-end;
}
/* animação */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
